import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Theme, useTheme } from '@lumapps/lumx/react';
import { getEmbedMapUrl } from '@lumapps/utils/maps/getEmbedMapUrl';
import { getMapUrlCoordinates } from '@lumapps/utils/maps/getMapUrlCoordinates';
import { getMapWebsiteName } from '@lumapps/utils/maps/getMapWebsiteName';
import { ElementRender } from '@lumapps/wrex/types';

import { EmbeddedMapElement } from '../../../types';

import './index.scss';

export const CLASSNAME = 'wrex-embedded-map';

export const EmbeddedMap: ElementRender<EmbeddedMapElement, HTMLDivElement> = ({
    element,
    elementRef,
    children,
    className,
    ...forwardedProps
}) => {
    const { url, title } = element ?? {};
    const { block, element: elementClassName } = useClassnames(CLASSNAME);
    // Used to handle html copy paste where url is already an embedded one
    const isGoogleMapEmbedUrl = url && /www\.google\.com\/maps\/embed/.test(url);
    const embedUrl = React.useMemo(() => {
        const urlCoords = url && getMapUrlCoordinates(url);
        return isGoogleMapEmbedUrl ? url : urlCoords && getEmbedMapUrl(urlCoords, getMapWebsiteName(url));
    }, [isGoogleMapEmbedUrl, url]);
    const theme = useTheme() || Theme.light;

    return (
        <div className={block({ [`theme-${theme}`]: true }, [className])} ref={elementRef} {...forwardedProps}>
            {children}
            <iframe
                className={elementClassName('embed')}
                title={title}
                src={embedUrl}
                frameBorder="0"
                allowFullScreen
                contentEditable={false}
            />
        </div>
    );
};

EmbeddedMap.displayName = 'embedded-map';
